// extracted by mini-css-extract-plugin
export var contrastLow = "_b-1";
export var externalLink = "_b-2";
export var externalLinkIcon = "_b-3";
export var link = "_b-0";
export var linkLabel = "_b-4";